import {fetchDistrictsData, IDistrictsDataParams} from "../api/fetch_districts_data";

export const fetchDistrictsWithCheck = async (params: IDistrictsDataParams) => {
    const response = await fetchDistrictsData(params);
    /**
     *  fetchDistrictsData above can return empty array in response, this means that there is no data from previous month.
     *  This occurs when something went wrong when generating the data in BD so we need to fetch data from 2 months earlier (fetchDistrictsData below)
     */
    if (response.length === 0) {
        return await fetchDistrictsData({...params, numberOfMonthsEarlier: 2});
    }

    return response;
};
import {fetchDistrictsData, IDistrictsDataParams} from "../api/fetch_districts_data";

export const fetchDistrictsWithCheck = async (params: IDistrictsDataParams) => {
    const response = await fetchDistrictsData(params);
    /**
     *  fetchDistrictsData above can return empty array in response, this means that there is no data from previous month.
     *  This occurs when something went wrong when generating the data in BD so we need to fetch data from 2 months earlier (fetchDistrictsData below)
     */
    if (response.length === 0) {
        return await fetchDistrictsData({...params, numberOfMonthsEarlier: 2});
    }

    return response;
};
